/**
 * Stats goals (`/v2/stats/goals`, F1.3) — the trainee manages their own goals
 * (create/update are self-only); a trainer READS a client's with `clientId`,
 * through the same consent-scoped access as the rest of the client's stats.
 * Max 3 ACTIVE is enforced by the BE (400). NOTE: the namespace is
 * `statsGoals` — the public `goals` domain (goal tags) is unrelated.
 */
import type { ApiCreateGoalDto, ApiUpdateGoalDto } from '@mfw/common';

import type { FetchGoalsArgs, ApiGoal } from './types/statsInsights.types';

import { patch, post, get } from './axios';

export const fetchGoals = async (args: FetchGoalsArgs = {}) => {
  const response = await get<ApiGoal[]>('/v2/stats/goals', {
    query: { clientId: args.clientId, status: args.status },
  });
  return response ?? null;
};

export const createGoal = async (dto: ApiCreateGoalDto) => {
  const response = await post<ApiGoal>('/v2/stats/goals', dto);
  // BE returns a raw row, but the `post` helper types a `{data}` wrapper — cast
  return (response ?? null) as ApiGoal | null;
};

export const updateGoal = async ({
  id,
  ...dto
}: ApiUpdateGoalDto & { id: string }) => {
  const response = await patch<ApiGoal>(`/v2/stats/goals/${id}`, dto);
  // BE returns a raw row, but the `patch` helper types a `{data}` wrapper — cast
  return (response ?? null) as ApiGoal | null;
};
